import React, { useState } from 'react';
import data from '../Doa.json';

const Doa = () => {
    const [contacts, setContacts] = useState(data);
    const [search, setSearch] = useState('');
  return (
   <div>
    <h2 className='text-secondary flex item-center justify-center text-3xl mb-5'>Kumpulan Doa-Doa Harian</h2>
    <div className="flex items-center justify-center mb-5">
    <div className="flex border-2 rounded">
        <input type="text" class="px-4 py-2 w-96" onChange={(e) => setSearch(e.target.value)} placeholder="Search..."/>
        <button className="flex items-center justify-center px-4 border-l">
            <svg className="w-6 h-6 text-gray-600" fill="currentColor" xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24">
                <path
                    d="M16.32 14.9l5.39 5.4a1 1 0 0 1-1.42 1.4l-5.38-5.38a8 8 0 1 1 1.41-1.41zM10 16a6 6 0 1 0 0-12 6 6 0 0 0 0 12z" />
            </svg>
        </button>
    </div>
</div>
        {data
            .filter((item) => {
                return search.toLowerCase() === ''
                  ? item
                  : item.doa.toLowerCase().includes(search);
              })
              .map((item, index) => (
            <div className='flex items-center justify-center'>
        <details class="w-4/5 bg-white border border-accent-primary cursor-pointer mb-3">
            <summary class="w-full bg-white text-xl font-medium flex justify-between px-4 py-3  after:content-['+']">{item.doa}</summary>
            <p class="px-4 py-3 text-xl font-medium ml-auto">
            {item.ayat}
            </p>
            <p class="px-4 py-3 font-medium">
            {item.latin}
            </p>
        </details>
    </div>
              ))}
    </div>
   
  )
}

export default Doa;